import { createContext } from 'react';
import type { ConfirmationContextValue } from '../../components/confirmation/types';

const ConfirmationContext = createContext<ConfirmationContextValue | null>(null);

export default ConfirmationContext;
